module.exports = __webpack_public_path__ + "static/media/loader.5be97134.svg";